/* eslint-disable class-methods-use-this */
import {SetStorage, GetStorage} from 'data/protocols/cache';

export class LocalStorageAdapter<T> implements SetStorage<T>, GetStorage<T> {
	set(key: string, value?: T): void {
		if (value) {
			localStorage.setItem(key, JSON.stringify(value));
		} else {
			localStorage.removeItem(key);
		}
	}

	get(key: string): T {
		return JSON.parse(localStorage.getItem(key) as string);
	}
}
